import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "col-7-medium col-12 radio-container" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "row small-gutter no-space" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = {
  key: 0,
  class: "col-2"
}
const _hoisted_9 = { class: "form-element" }
const _hoisted_10 = { class: "row justify-between no-space" }
const _hoisted_11 = { class: "col-5" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "col-7"
}
const _hoisted_14 = { class: "total-share samples" }
const _hoisted_15 = { class: "text-total-share" }

import TextField from '@/components/CommonUI/TextField.vue'
import { ErrorMessage, useField, useFieldArray, useValidateField } from 'vee-validate'
import IconUI from '@/components/CommonUI/IconUI.vue'
import PushButtons from '@/components/CommonUI/PushButtons.vue'
import { emptySample, maxWorkSamplesCount } from '@/constants'
import { computed, watch } from 'vue'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import { useGettext } from 'vue3-gettext'


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkSamples',
  setup(__props) {

const { $gettext } = useGettext()
const { value: hasSamples } = useField<boolean>('hasSamples')
const { remove, push, fields, replace } = useFieldArray('samples')
const validateSamples = useValidateField('samples')

const samples = computed(() => fields.value.map(entry => entry.value as WorkSample))
const totalShare = computed(() => {
  const entriesWithData = samples.value.filter(sample => sample.writers_names && sample.title && sample.share)
  return entriesWithData.reduce((acc, { share }) => parseFloat(String(acc)) + parseFloat(String(share)), 0)
})

watch(hasSamples, value => {
  if (!value) {
    replace([structuredClone(emptySample)])
    validateSamples()
  }
})

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, [
      _withDirectives((_openBlock(), _createElementBlock("span", null, [
        _createTextVNode("Samples")
      ])), [
        [_directive_translate]
      ]),
      _withDirectives(_createVNode(IconUI, {
        class: "tooltip-icon",
        name: "tooltip",
        fill: "info",
        "data-testid": "is-user-have-samples-tooltip"
      }, null, 512), [
        [_directive_tippy, { content: _unref($gettext)('Please confirm if your Musical Work includes any elements of a separate existing work. You can only register works featuring samples if you have entered into a direct agreement with both the copyright and sound recording rights owners of the original work.') }]
      ])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_2, [
        _createTextVNode(" Have you used any samples in this composition? ")
      ])), [
        [_directive_translate]
      ]),
      _createVNode(PushButtons, {
        modelValue: _unref(hasSamples),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(hasSamples) ? (hasSamples).value = $event : null))
      }, null, 8, ["modelValue"])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (entry, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: entry.key,
          class: _normalizeClass(["row", { 'no-space': index !== _unref(fields).length - 1 }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TextField, {
              name: `samples[${index}].title`,
              label: _unref($gettext)('Title of work used'),
              "hide-label": index !== 0
            }, null, 8, ["name", "label", "hide-label"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TextField, {
              name: `samples[${index}].writers_names`,
              "tooltip-info-text": _unref($gettext)('You can add multiple writer names separated by commas. Eg, John Smith, Jane Doe, Joe Blogs.'),
              label: _unref($gettext)('Writer(s) name(s)'),
              "hide-label": index !== 0
            }, null, 8, ["name", "tooltip-info-text", "label", "hide-label"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(TextField, {
                  label: _unref($gettext)('Share'),
                  unit: "%",
                  name: `samples[${index}].share`,
                  "tooltip-info-text": _unref($gettext)('Add the share for this sample. This share will not be claimed by Ditto.'),
                  "hide-label": index !== 0
                }, null, 8, ["label", "name", "tooltip-info-text", "hide-label"])
              ]),
              (index !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(IconUI, {
                        class: "delete-button",
                        name: "rubbish-bin",
                        fill: "body",
                        "data-testid": `remove-sample${index}`,
                        onClick: ($event: any) => (_unref(remove)(index))
                      }, null, 8, ["data-testid", "onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      }), 128)),
      _createVNode(_unref(ErrorMessage), { name: "samples" }, {
        default: _withCtx(({ message }) => [
          _createVNode(NotificationUI, {
            class: "col-10",
            message: message,
            type: "error outline",
            "icon-fill": "error",
            "icon-name": "danger"
          }, null, 8, ["message"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "button text-button action-button",
            disabled: samples.value.length === _unref(maxWorkSamplesCount),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(push)(_unref(emptySample))))
          }, [
            _createVNode(IconUI, { name: "plus-circle" }),
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              _createTextVNode("Add another sample")
            ])), [
              [_directive_translate]
            ])
          ], 8, _hoisted_12)
        ]),
        (totalShare.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_15, [
                  _createTextVNode("Total to deduct from writer's share:")
                ])), [
                  [_directive_translate]
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(totalShare.value > 100 ? 'text-error' : 'text-success')
                }, _toDisplayString(totalShare.value) + "% ", 3),
                _createVNode(IconUI, {
                  name: totalShare.value > 100 ? 'error' : 'verified',
                  fill: totalShare.value > 100 ? 'error' : 'success'
                }, null, 8, ["name", "fill"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, _unref(hasSamples)]
    ])
  ], 64))
}
}

})